export default __webpack_public_path__ + "static/media/default_badge.7c58b1c3.svg";